export { default } from './GreatDeals';
